import { TabStyles } from '@tableau/widgets';
import { cssClass, divWithStyle } from '../../../style';

export const DIALOG_WIDTH: number = 500;

export function helpTextDiv(testId: string) {
  return divWithStyle(testId, '-help-text', {
    paddingTop: TabStyles.Spacing.DefaultSpace,
  });
}

export function buttonContainerDiv(testId: string) {
  return divWithStyle(testId, '-button-container', {
    paddingTop: TabStyles.Spacing.DefaultSpace,
    float: 'right'
  });
}

export function inputHintDiv(testId: string) {
  return divWithStyle(testId, '-input-hint-text', {
    paddingTop: TabStyles.Spacing.MediumSpace,
    // paddingBottom: TabStyles.Spacing.DefaultSpace,
    fontSize: TabStyles.Typography.Sizing.Tiny,
    color: TabStyles.Typography.Color.PrimaryLight,
  });
}

export function textAreaCssClass(testId: string) {
  return cssClass(testId, 'editableMessage', {
    fontWeight: 'normal',
    boxSizing: 'border-box',
    width: '100%',
    fontSize: TabStyles.Typography.Sizing.Default,
    outline: 'none',
    marginBottom: TabStyles.Spacing.MediumSpace
  });
}

export const cancelButtonStyle: React.CSSProperties = {
  marginRight: TabStyles.Spacing.MediumSpace,
};

export const buttonStyleSubmitting: React.CSSProperties = {
  verticalAlign: 'sub',
};

export const dialogBodyStyle: React.CSSProperties = {
  paddingTop: TabStyles.Spacing.MediumSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace,
};

export const overLimitCounter: React.CSSProperties = {
  color: TabStyles.Colors.AttentionLight
};
